// Bus nhỏ để một mục bất kỳ của cổng khách (vd thẻ "Giới thiệu của tôi") mở
// bong bóng chat kèm chủ đề, mà không phải luồn prop qua
// CustomerBookingPortalPage — trang đó thuộc kế hoạch khác, khối này chỉ được
// thêm đúng một dòng mount.
import type { ChatTopic } from "./api";

type Listener = (topic: ChatTopic) => void;

const listeners = new Set<Listener>();

export function openChatBubble(topic: ChatTopic = "general"): void {
  listeners.forEach((listener) => listener(topic));
}

export function subscribeChatBubble(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
